import { Chart } from 'chart.js';
import { readChartTheme } from './chart-helpers';

/**
 * Vertical crosshair plugin - draws a dashed vertical line at the hover point.
 * Used by cs-progress-chart to show alignment across stacked axes.
 *
 * Configuration via chart options:
 * plugins: {
 *   verticalCrosshair: {
 *     componentRef: this  // component reference to check compact mode
 *   }
 * }
 */
export const verticalCrosshairPlugin = {
  id: 'verticalCrosshair',
  afterDraw: (chart: Chart) => {
    // skip drawing in compact mode - check both componentRef and tooltip enabled state
    const componentRef = ((chart.options as any).plugins?.verticalCrosshair as any)?.componentRef;
    const tooltipEnabled = (chart.options as any).plugins?.tooltip?.enabled;

    if (componentRef?.compact || tooltipEnabled === false) {
      return;
    }

    if (chart.tooltip?.getActiveElements()?.length) {
      const activePoint = chart.tooltip.getActiveElements()[0];
      const ctx = chart.ctx;
      const x = activePoint.element.x;
      const topY = chart.chartArea.top;
      const bottomY = chart.chartArea.bottom;

      // read the tick colour at draw time, so the line follows the theme as it is now
      const tickColor = readChartTheme().tick;

      ctx.save();
      ctx.lineWidth = 1.5;
      ctx.setLineDash([7, 5]);
      ctx.strokeStyle = tickColor;
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.stroke();
      ctx.restore();
    }
  }
};
